import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import Check from "@mui/icons-material/Check";

const CustomStepIcon = (props) => {
  const { active, completed, icon } = props;

  return (
    <Box
      sx={{
        width: 28,
        height: 28,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: completed ? "#4caf50" : active ? "#fb8c00" : "#9e9e9e",
        color: "#fff",
        fontSize: "14px",
        fontWeight: "bold",
      }}
    >
      {completed ? <Check sx={{ fontSize: 20 }} /> : icon}
    </Box>
  );
};

CustomStepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};

export default CustomStepIcon;
